import { AppVersionType } from "./appVersionType";

export const initialState: AppVersionType = {
  fetching: false,
  error: null,
  message: null,
  success: null,
  statusCode: null,
  versionNumber: null,
};
